import axios from 'axios';

import * as endpoints from '../endpoints';
import { constants } from '../constants';

const baseUrl = constants.baseURL;

export const getGeneralDocsByUserId = async (userId) => {
  return axios({
    method: 'get',
    url: `${endpoints.GeneralDoc.BASE}/${userId}`,
    baseURL: baseUrl,
  }).then((response) => response.data.result);
};
